import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../utils/translations';
import Logo from './Logo';

const SharedHeader = () => {
  const { language, changeLanguage } = useLanguage();
  const t = (key) => getTranslation(language, key);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeMenu = () => setIsMenuOpen(false);

  return (
    <>
      <header className="py-6 px-4 border-b border-purple-700">
        <div className="container mx-auto flex justify-between items-center">
          <Link to="/" className="flex items-center space-x-3">
            <Logo size="medium" />
            <span className="text-xl font-bold">{t('appName')}</span>
          </Link>
          
          <div className="flex items-center space-x-6">
            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-6">
              <Link to="/" className="text-gray-300 hover:text-white transition">
                {t('home')}
              </Link>
              <Link to="/about" className="text-gray-300 hover:text-white transition">
                {t('aboutUs')}
              </Link>
              <Link to="/interes" className="text-gray-300 hover:text-white transition">
                {language === 'es' ? 'Interés' : language === 'en' ? 'Interest' : 'Interesse'}
              </Link>
              <Link to="/innovacion-y-hoja-de-ruta" className="text-gray-300 hover:text-white transition">
                {language === 'es' ? 'Innovación & Roadmap' : language === 'en' ? 'Innovation & Roadmap' : 'Inovação & Roadmap'}
              </Link>
              <Link to="/politica-de-privacidad" className="text-gray-300 hover:text-white transition">
                {t('privacyPolicy')}
              </Link>
            </div>
            
            {/* Language Selector */}
            <div className="flex items-center space-x-1 bg-purple-800 rounded-lg px-2 py-1">
              {['es', 'en', 'pt'].map((lang) => (
                <button
                  key={lang}
                  onClick={() => changeLanguage(lang)}
                  className={`px-2 py-1 rounded text-sm font-medium transition ${
                    language === lang
                      ? 'bg-yellow-500 text-black'
                      : 'text-gray-300 hover:text-white'
                  }`}
                >
                  {lang.toUpperCase()}
                </button>
              ))}
            </div>
            
            {/* Mobile Hamburger */}
            <button
              onClick={toggleMenu}
              className="md:hidden text-white p-2 focus:outline-none"
              aria-label="Menu"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                {isMenuOpen ? (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                ) : (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                )}
              </svg>
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      {isMenuOpen && (
        <div className="fixed inset-0 z-50 bg-purple-900 bg-opacity-95 md:hidden">
          <div className="flex flex-col items-center justify-center h-full space-y-8">
            <button
              onClick={closeMenu}
              className="absolute top-6 right-6 text-white text-3xl"
              aria-label="Close Menu"
            >
              ×
            </button>
            
            <Link
              to="/"
              className="text-white text-2xl hover:text-yellow-400 transition"
              onClick={closeMenu}
            >
              {t('home')}
            </Link>
            
            <Link
              to="/about"
              className="text-white text-2xl hover:text-yellow-400 transition"
              onClick={closeMenu}
            >
              {t('aboutUs')}
            </Link>
            
            <Link
              to="/interes"
              className="text-white text-2xl hover:text-yellow-400 transition"
              onClick={closeMenu}
            >
              {language === 'es' ? 'Interés' : language === 'en' ? 'Interest' : 'Interesse'}
            </Link>
            
            <Link
              to="/innovacion-y-hoja-de-ruta"
              className="text-white text-2xl hover:text-yellow-400 transition"
              onClick={closeMenu}
            >
              {language === 'es' ? 'Innovación & Roadmap' : language === 'en' ? 'Innovation & Roadmap' : 'Inovação & Roadmap'}
            </Link>
            
            <Link
              to="/politica-de-privacidad"
              className="text-white text-2xl hover:text-yellow-400 transition"
              onClick={closeMenu}
            >
              {t('privacyPolicy')}
            </Link>
          </div>
        </div>
      )}
    </>
  );
};

export default SharedHeader;
